import { render } from "./AsideSidebar.vue?vue&type=template&id=6d7358b0"
import script from "./AsideSidebar.vue?vue&type=script&lang=js"
export * from "./AsideSidebar.vue?vue&type=script&lang=js"

import "./AsideSidebar.vue?vue&type=style&index=0&id=6d7358b0&lang=stylus"

import exportComponent from "C:\\projects\\_personal\\poland-shop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__